module.exports = __webpack_public_path__ + "static/notifications-c88c0a81dbd51c064720f8b516119f8b.png";